import { ShortlistModel } from 'models';

export const adaptShortList = (shortList: any): ShortlistModel | null => {
  if (!shortList || !shortList.metaData) {
    return null;
  }

  return {
    favorited: shortList.favorited,
    saveUrl: shortList.saveUrl,
    removeUrl: shortList.removeUrl,
    meta: {
      hotelId: shortList.metaData.hotelId,
      chkIn: shortList.metaData.chkIn,
      chkOut: shortList.metaData.chkOut,
      roomConfiguration: shortList.metaData.roomConfiguration,
    },
  };
};
